import * as React from 'react'
import { styled } from '@mui/material/styles'
import { useDownloadFromBlob } from 'utils/useDownloadFromBlob'
import Button from '@mui/material/Button'
import { Navigate } from 'react-router-dom'
import { useGetRequestForProposalPdfQuery, useGetRequestForProposalPublicPdfQuery } from 'proposals/requestForProposal/queries/useRequestForProposalQuery'
import { AxiosResponse } from 'axios'
import { useTranslation } from 'react-i18next'

const PREFIX = 'RequestForProposalDownloadPdf'

const classes = {
  root: `${PREFIX}-root`
}

const Root = styled('div')(({ theme: {  spacing } }) => ({
  [`&.${classes.root}`]: {
    marginTop: spacing(3)
  }
}))

const RequestForProposalDownloadPdf: React.FC<{ rfpId?: string; uniqueToken?: string; rfpTitle: string }> = ({ rfpId, uniqueToken, rfpTitle }) => {
  const downloadFromBlob = useDownloadFromBlob()
  const { t } = useTranslation()

  const { mutate: downloadPdf, isPending: isFetching, isError } = useGetRequestForProposalPdfQuery()
  const { mutate: downloadPdfPublic, isPending: isFetchingPublic, isError: isErrorPublic } = useGetRequestForProposalPublicPdfQuery()

  const handleClick = () => {
    if (rfpId) {
      downloadPdf(rfpId, {
        onSuccess: (response: AxiosResponse<string>) => {
          downloadFromBlob(response.data, rfpTitle, { type: 'application/pdf' })
        }
      })
    } else {
      downloadPdfPublic(uniqueToken!, {
        onSuccess: (response: AxiosResponse<string>) => {
          downloadFromBlob(response.data, rfpTitle, { type: 'application/pdf' })
        }
      })
    }
  }

  if (isError || isErrorPublic) {
    return <Navigate to={`/error`} replace />
  }

  return (
    <Root className={classes.root}>
      <Button color="grey" variant="outlined" onClick={handleClick} disabled={isFetching || isFetchingPublic}>
        {t('download-request-for-proposal')}
      </Button>
    </Root>
  )
}

export default RequestForProposalDownloadPdf
